<template>
    <div class="book-item-box" :class="{ inMyBook }" @click="routerCourse(book)">
        <div class="book-item" :style="{ backgroundImage: 'url(' + book.cover + ')' }">
            <template v-if="!hideHandler">
                <div class="book-top">
                    <div class="has-buy" v-if="book.isPaid && !phoneMode">已购买</div>
                    <a-tooltip title="阅读数据" v-if="!book.single_url && book.isPaid">
                        <div class="svg-box" @click.stop="portraitsBook = book">
                            <svg class="icon-svg">
                                <use xlink:href="#icon-statistics"></use>
                            </svg>
                        </div>
                    </a-tooltip>
                    <a-tooltip title="详情">
                        <div class="svg-box info" @click="routerInfo(book)" @click.stop>
                            <svg class="icon-svg">
                                <use xlink:href="#icon-info"></use>
                            </svg>
                        </div>
                    </a-tooltip>
                </div>
                <div class="book-bottom">
                    <div class="book-tag" v-if="book.hasMetaverse">元宇宙</div>
                    <div class="join-class-box" v-if="!book.single_url && book.isPaid">
                        <div class="join-class" v-if="!book.fk_book_class_id">
                            <a-tooltip title="加入教材班">
                                <div class="svg-box" @click.stop="joinBook = book">
                                    <svg class="icon-svg">
                                        <use xlink:href="#icon-join-class"></use>
                                    </svg>
                                </div>
                            </a-tooltip>
                        </div>
                        <div class="join-class joined" v-else>
                            <a-tooltip title="已加入教材班">
                                <div class="svg-box">
                                    <svg class="icon-svg">
                                        <use xlink:href="#icon-student-count"></use>
                                    </svg>
                                </div>
                            </a-tooltip>
                        </div>
                    </div>
                </div>
            </template>
            <div class="book-shadow" :class="{ 'dark-cover': book.isDarkCover }"></div>
        </div>
        <div class="book-info" v-if="!inMyBook">
            <div class="book-name" :class="{ 'ellipsis': phoneMode, 'ellipsis2': !phoneMode }">{{ book.name }}</div>
            <div class="book-sub-name" v-if="book.chief_editor_name">{{ book.chief_editor_name }}</div>
            <div class="book-price">￥{{ book.price }}</div>
        </div>
    </div>

    <JoinClass :joinBook="joinBook" @closebox="joinBook = null" @joinSuccess="joinSuccess" v-if="joinBook">
    </JoinClass>
    <PortraitsBox :book="portraitsBook" @close="portraitsBook = null" v-if="portraitsBook"></PortraitsBox>
</template>
<script setup>

import { computed, onMounted, ref } from 'vue'
import store from "@/store";
import router from '@/router'
import { message } from 'ant-design-vue';

import JoinClass from "@/component/mycourse/JoinClass.vue";
import PortraitsBox from "@/component/personal/portraits-info/PortraitsBox.vue";

const props = defineProps({
    book: Object,
    inMyBook: Boolean,
    hideHandler: Boolean
})

const userInfo = computed(() => store.state.userInfo)
const phoneMode = computed(() => store.state.phoneMode)

const shareBook = ref(null);
const portraitsBook = ref(null);
const joinBook = ref(null);

const emit = defineEmits(['joinSuccess'])

onMounted(() => {

});

//跳转
function routerCourse(item) {
    const { isPaid } = item;
    if (isPaid) {
        routerStudy(item);
    }
    else {
        routerInfo(item);
    }
}

//跳转详情
function routerInfo(item) {
    const { storeUrl, isOtherStore } = item;

    const url = `/course-info/${item.pk_store_book_id}`
    if (isOtherStore) {
        if (!this.userInfo) this.$router.push({ path: 'login' });
        else window.open(`${storeUrl}/${url}`);
    }
    else {
        $("#content").css("overflow-y", "auto");
        $("#content").css("padding-right", "0px");
        router.push(`/course-info/${item.pk_store_book_id}`);
    }
}

//学习
function routerStudy(item) {
    const { pk_store_book_id, system_id, single_url, storeUrl, isOtherStore } = item;
    let url = `/bookReader/${pk_store_book_id}`;
    if (single_url) {
        url = `${single_url}?pk_store_book_id=${pk_store_book_id}&system_id=${system_id}`;
    }

    if (isOtherStore) {
        url = `${storeUrl}${url}`
    }
    if (store.state.isElectron) {
        url = `https://yuanxi.online/bookReader/${pk_store_book_id}?pk_store_book_id=${pk_store_book_id}&system_id=${system_id}`
    }
    window.open(url)
}

function joinSuccess(data) {
    emit('joinSuccess', data);
}

function donwload(book) {
    const loadding = message.loading(`下载${book.name}中`, 0);
    api.download.downloadTextbook({
        "PK_PublishingGuid": book.fk_publishing_id,
        "PK_OutlineGuid": book.extension_info.outlineId,
        extensionInfo: book.extension_info
    }).then(res => {
        message.success(`下载${book.name}成功`);
        loadding();
    })
}

</script>

<style lang="scss" scoped>
.book-item-box {
    margin: 40px 20px;
    width: calc(100%/5 - 40px);

    @media screen and (max-width: 1000px) {
        & {
            width: calc(100%/4 - 40px);
        }
    }

    @media screen and (max-width: 800px) {
        & {
            width: calc(100%/3 - 40px);
        }
    }

    &.inMyBook {
        margin: 100px 30px;
        width: calc(100%/4 - 60px);

        @media screen and (max-width: 1000px) {
            & {
                width: calc(100%/3 - 60px);
            }
        }

        @media screen and (max-width: 800px) {
            & {
                width: calc(100%/2 - 60px);
            }
        }

        .book-item {
            width: 200px;
            height: 300px;
            padding-bottom: 0;
        }
    }

    .book-item {
        width: 100%;
        padding-bottom: 150%;
        cursor: pointer;
        transition: all .3s ease;
        text-align: center;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        border-radius: 7px;
        overflow: hidden;
        position: relative;
        transition: all .3s ease;
        box-shadow: var(--box-shadow);


        &:hover {
            transform: translateY(-15px);
            -webkit-transform: translateY(-15px);

            .book-top {
                .svg-box {
                    opacity: 1;
                }
            }

            .book-bottom {
                .join-class {
                    opacity: 1;
                }
            }
        }

        &.hide {
            display: none;
        }

        .svg-box {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 24px;
            height: 24px;
            border-radius: 50%;
            background-color: #ffffff73;
            transition: all .3s ease;

            &:hover {
                background-color: var(--primary-color) !important;
            }

            .icon-svg {
                font-size: 20px;
            }
        }

        .book-top {
            top: 0;
            left: 0;
            width: 100%;
            padding: 10px 15px;
            position: absolute;
            z-index: 1;
            display: flex;
            align-items: center;
            justify-content: flex-end;

            .has-buy {
                padding: 0px 7px;
                margin-right: auto;
                font-size: 12px;
                border-radius: 10px;
                background-color: #6b6b6b6b;
                color: #fff;
            }

            .svg-box {
                margin-left: 5px;
                opacity: 0;
            }
        }

        .book-bottom {
            z-index: 1;
            bottom: 0;
            left: 0;
            padding: 5px 15px;
            height: 42px;
            width: 100%;
            position: absolute;
            display: flex;
            align-items: center;
            justify-content: flex-end;

            .book-tag {
                padding: 2px 10px;
                color: #ffffff;
                background-color: #7e7b7b80;
                border-radius: 15px;
                font-size: 12px;
                margin-right: auto;
            }

            .join-class {
                opacity: 0;
                display: flex;
                align-items: center;
                transition: all .3s ease;

                &.joined {
                    opacity: 1;

                    .svg-box {
                        .icon-svg {
                            color: var(--primary-color);
                        }
                    }
                }
            }

            .book-status {
                margin-left: auto;

                &.hide {
                    opacity: 0;
                    width: 0;
                }

                >div {
                    display: flex;
                    align-items: center;
                    padding: 2px 8px;
                    border-radius: 16px;
                    background-color: #333333b8;
                    font-size: 14px;

                    svg {
                        font-size: 20px;
                        margin-right: 5px;
                    }
                }
            }
        }
    }

    .book-info {
        margin-top: 10px;
        font-size: 14px;
        text-align: center;

        .book-name {
            font-size: 17px;
        }

        .book-sub-name {
            color: #999999;
        }

        .book-price {
            color: var(--primary-color);
        }
    }
}

#content {
    &.phone-mode {
        .book-item-box {
            width: calc(100%/2 - 40px);
            margin: 30px 20px;

            &.inMyBook {
                width: calc(50% - 30px);
                margin: 50px 15px;

                .book-item {
                    transform: none;
                    margin: 0 auto;
                    width: 143px;
                    height: 213px;
                }
            }

            .book-item {
                transform: none;

                .book-top {
                    padding: 5px 8px;

                    .svg-box {
                        opacity: 1;
                    }
                }

                .book-bottom {
                    padding: 0px 8px;
                    height: 30px;

                    .join-class {
                        opacity: 1;
                    }
                }
            }

            .book-info {
                font-size: 12px;

                .book-name {
                    font-size: 15px;
                }

                .book-price {
                    color: var(--primary-color);
                }
            }
        }
    }
}
</style>